<template>
  <div class="setting-page">
    <section class="setting-profile-card">
      <div class="setting-profile-inner">
        <div class="setting-avatar-wrap">
          <img
            class="setting-avatar"
            :src="avatarUrl"
            alt=""
          >
        </div>
        <div class="setting-profile-fields">
          <div class="setting-field">
            <span class="setting-field__label">{{ $t('setting.name') }}</span>
            <span class="setting-field__value">{{ $store.state.authUser.name }}</span>
          </div>
          <div class="setting-field">
            <span class="setting-field__label">{{ $t('setting.balance') }}</span>
            <span class="setting-field__value setting-field__value--accent">
              {{ Number($store.state.amount).toLocaleString() }} MMK
            </span>
          </div>
          <div class="setting-field">
            <span class="setting-field__label">{{ $t('setting.withdraw') }}</span>
            <span class="setting-field__value">
              {{ Number($store.state.totalWithdraw).toLocaleString() }} MMK
            </span>
          </div>
          <div class="setting-field">
            <span class="setting-field__label">{{ $t('setting.phone') }}</span>
            <span class="setting-field__value">{{ blurLastFiveCharacters($store.state.authUser.phone) }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="setting-quick-actions" aria-label="Wallet shortcuts">
      <button
        type="button"
        class="setting-quick-tile"
        @click="$router.push('/deposit')"
      >
        <span class="setting-quick-tile__icon">
          <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/wallet.png" alt="">
        </span>
        <span class="setting-quick-tile__label">{{ $t('setting.deposit') }}</span>
      </button>
      <button
        type="button"
        class="setting-quick-tile"
        @click="$router.push('/withdraw')"
      >
        <span class="setting-quick-tile__icon">
          <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/withdraw.png" alt="">
        </span>
        <span class="setting-quick-tile__label">{{ $t('setting.withdraw') }}</span>
      </button>
      <button
        type="button"
        class="setting-quick-tile"
        @click="$router.push('/history')"
      >
        <span class="setting-quick-tile__icon">
          <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/transaction.png" alt="">
        </span>
        <span class="setting-quick-tile__label">{{ $t('setting.transaction') }}</span>
      </button>
    </section>

    <section class="setting-menu-card">
      <ul class="setting-menu-list">
        <li class="setting-menu-item setting-menu-item--static">
          <span class="setting-menu-item__icon">
            <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/id-card.png" alt="">
          </span>
          <span class="setting-menu-item__text">{{ $t('setting.name') }} — {{ $store.state.authUser.user_name }}</span>
        </li>
        <li
          class="setting-menu-item"
          data-toggle="modal"
          data-target="#editUserPassword"
        >
          <span class="setting-menu-item__left">
            <span class="setting-menu-item__icon">
              <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/write.png" alt="">
            </span>
            <span class="setting-menu-item__text">{{ $t('setting.update_password') }}</span>
          </span>
          <i class="fas fa-chevron-right setting-menu-item__chev" aria-hidden="true"></i>
        </li>
        <li
          class="setting-menu-item"
          @click="() => $router.push('/banking')"
        >
          <span class="setting-menu-item__left">
            <span class="setting-menu-item__icon">
              <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/bank.png" alt="">
            </span>
            <span class="setting-menu-item__text">{{ $t('setting.bank_account') }}</span>
          </span>
          <i class="fas fa-chevron-right setting-menu-item__chev" aria-hidden="true"></i>
        </li>
        <li class="setting-menu-item setting-menu-item--dropdown dropdown">
          <div
            id="navbar-language"
            class="setting-menu-item__row setting-menu-dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="setting-menu-item__left">
              <span class="setting-menu-item__icon">
                <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/language.png" alt="">
              </span>
              <span class="setting-menu-item__text">{{ $t('setting.update_language') }}</span>
            </span>
            <i class="fas fa-chevron-right setting-menu-item__chev" aria-hidden="true"></i>
          </div>
          <div
            class="dropdown-menu dropdown-menu-right setting-lang-menu"
            aria-labelledby="navbar-language"
          >
            <a class="dropdown-item" @click="setLangLocalstorage('en')"><img
              src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/united-kingdom.png"
              alt=""
              class="mr-2"
              style="width: 20px; height: 20px"
            >{{ $t('en') }}</a>
            <div class="dropdown-divider" />
            <a class="dropdown-item" @click="setLangLocalstorage('mm')"><img
              src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/myanmar.png"
              alt=""
              class="mr-2"
              style="width: 20px; height: 20px"
            >{{ $t('mm') }}</a>
            <div class="dropdown-divider" />
            <a class="dropdown-item" @click="setLangLocalstorage('cn')"><img
              src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/china.png"
              alt=""
              class="mr-2"
              style="width: 20px; height: 20px"
            >{{ $t('cn') }}</a>
            <div class="dropdown-divider" />
            <a class="dropdown-item" @click="setLangLocalstorage('th')"><img
              src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/thailand.png"
              alt=""
              class="mr-2"
              style="width: 20px; height: 20px"
            >{{ $t('th') }}</a>
          </div>
        </li>
      </ul>

      <div class="setting-menu-divider" />

      <ul class="setting-menu-list">
        <li
          class="setting-menu-item setting-menu-item--logout"
          @click="logout()"
        >
          <span class="setting-menu-item__left">
            <span class="setting-menu-item__icon">
              <img src="https://storage.googleapis.com/spacetech2/shwemyanmar/logout.png" alt="">
            </span>
            <span class="setting-menu-item__text">{{ $t('setting.logout') }}</span>
          </span>
        </li>
      </ul>
    </section>

    <div
      id="editUserPassword"
      ref="passwordModal"
      class="modal fade setting-password-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-sm"
        role="document"
      >
        <div class="modal-content setting-modal-content">
          <div class="modal-body setting-modal-body">
            <h3 class="setting-modal-title">{{ $t('setting.update_password') }}</h3>
            <div class="form-group">
              <label class="setting-label">{{ $t('setting.old_password') }}</label>
              <div class="mt-1">
                <input
                  v-model="password.old"
                  class="form-control setting-input"
                  type="password"
                  autocomplete="current-password"
                >
              </div>
              <span class="text-danger small">{{ errors.old }}</span>
            </div>
            <div class="form-group">
              <label class="setting-label">{{ $t('setting.new_password') }}</label>
              <div class="mt-1">
                <input
                  v-model="password.new"
                  class="form-control setting-input"
                  type="password"
                  autocomplete="new-password"
                >
              </div>
              <span class="text-danger small">{{ errors.new }}</span>
            </div>
            <div class="form-group">
              <label class="setting-label">{{ $t('setting.confirm_password') }}</label>
              <div class="mt-1">
                <input
                  v-model="password.confirm"
                  class="form-control setting-input"
                  type="password"
                  autocomplete="new-password"
                >
              </div>
              <span class="text-danger small">{{ errors.confirm || errors.confirmPassword }}</span>
            </div>
            <div class="text-center pt-2">
              <button
                type="button"
                class="btn setting-btn-primary"
                @click="changeNewPassword"
              >
                <span v-if="!isConfirm">{{ $t('setting.update') }}</span>
                <Loading
                  v-if="isConfirm"
                  color="#ffffff"
                  size="24"
                  class="px-4 py-0"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
    };
  },
  computed: {
    avatarUrl() {
      const name = (this.$store.state.authUser && this.$store.state.authUser.name) || 'User';
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=991b1b&color=fff&size=92&bold=true`;
    },
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    blurLastFiveCharacters(inputString = '0000000000') {
      const length = inputString.length;
      if (length >= 7) {
        const firstPart = inputString.substring(length - 5, length);
        const blurredCharacters = '*'.repeat(length - 5);
        return blurredCharacters + firstPart;
      }
      return inputString;
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language;
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = {};
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            // this.$router.go();
          } else {
            this.$router.push('/home');
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
    movePasswordModalToBody() {
      const el = this.$refs.passwordModal;
      if (el && el.parentNode && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
    this.$nextTick(() => {
      this.movePasswordModalToBody();
    });
  },
  beforeDestroy() {
    const el = typeof document !== 'undefined' && document.getElementById('editUserPassword');
    if (typeof window !== 'undefined' && window.$ && el) {
      try {
        $(el).modal('hide');
      } catch (e) {
        /* ignore */
      }
    }
  },
};
</script>
<style scoped>
.setting-page {
  min-height: 100vh;
  padding: 12px 12px 18rem;
  /* scroll on .index-scroll-main only — nested overflow breaks Bootstrap modal touches on mobile */
  background:
    radial-gradient(ellipse 100% 50% at 50% 0%, rgba(215, 25, 33, 0.12) 0%, transparent 50%),
    linear-gradient(180deg, #FFE8E8 0%, #fff8f5 18%, #ffffff 42%, #f6f4f5 100%);
}

.setting-profile-card,
.setting-quick-actions,
.setting-menu-card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(201, 162, 39, 0.28);
  border-radius: 16px;
  box-shadow: 0 8px 28px rgba(58, 8, 10, 0.07);
  margin-bottom: 12px;
}

.setting-profile-inner {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 14px;
}

.setting-avatar-wrap {
  flex-shrink: 0;
}

.setting-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(245, 197, 24, 0.55);
  box-shadow: 0 6px 20px rgba(215, 25, 33, 0.22);
}

.setting-profile-fields {
  flex: 1;
  min-width: 0;
  padding-top: 4px;
}

.setting-field {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px 10px;
  margin-bottom: 8px;
  font-size: 0.875rem;
  line-height: 1.35;
}

.setting-field:last-child {
  margin-bottom: 0;
}

.setting-field__label {
  flex: 0 0 92px;
  color: #6b5e5e;
  font-weight: 600;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.setting-field__value {
  flex: 1;
  min-width: 0;
  color: #1a1212;
  font-weight: 600;
  word-break: break-word;
}

.setting-field__value--accent {
  color: #D71921;
}

.setting-quick-actions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 12px 10px;
}

.setting-quick-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 6px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #FFF5F5 100%);
  border: 1px solid rgba(201, 162, 39, 0.3);
  box-shadow: 0 2px 10px rgba(58, 8, 10, 0.06);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.setting-quick-tile:active {
  transform: scale(0.97);
}

.setting-quick-tile__icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(215, 25, 33, 0.1);
}

.setting-quick-tile__icon img {
  width: 26px;
  height: 26px;
  object-fit: contain;
  filter: brightness(0) saturate(100%) invert(14%) sepia(90%) saturate(4200%) hue-rotate(345deg) brightness(0.85) contrast(1.1);
}

.setting-quick-tile__label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #3A080A;
  text-align: center;
  line-height: 1.25;
  white-space: nowrap;
}

.setting-menu-card {
  padding: 4px 0 8px;
  overflow: visible;
}

.setting-menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.setting-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 10px 14px;
  margin: 0 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.setting-menu-item:not(.setting-menu-item--static):hover {
  background: rgba(215, 25, 33, 0.08);
}

.setting-menu-item--static {
  cursor: default;
  opacity: 0.95;
}

.setting-menu-item--dropdown {
  display: block;
  position: relative;
  padding: 0;
  margin: 0 8px;
}

.setting-menu-dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 10px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.setting-menu-dropdown-toggle:hover {
  background: rgba(215, 25, 33, 0.08);
}

.setting-menu-item__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.setting-menu-item__icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(215, 25, 33, 0.1);
}

.setting-menu-item__icon img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: brightness(0) saturate(100%) invert(14%) sepia(90%) saturate(4200%) hue-rotate(345deg) brightness(0.85) contrast(1.1);
}

.setting-menu-item__text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1a1212;
}

.setting-menu-item__chev {
  font-size: 0.75rem;
  color: #9B1218;
  flex-shrink: 0;
}

.setting-menu-item--logout .setting-menu-item__text {
  color: #D71921;
}

.setting-menu-item--logout:hover {
  background: rgba(215, 25, 33, 0.1);
}

.setting-menu-divider {
  height: 1px;
  margin: 8px 16px 12px;
  background: linear-gradient(90deg, transparent, rgba(201, 162, 39, 0.45), transparent);
  border: none;
}

.setting-lang-menu {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 4px;
  border-radius: 12px;
  border: 1px solid rgba(201, 162, 39, 0.3);
  box-shadow: 0 12px 40px rgba(58, 8, 10, 0.12);
  padding: 6px 0;
  z-index: 1050;
}

.setting-lang-menu .dropdown-item:hover,
.setting-lang-menu .dropdown-item:focus {
  background: rgba(215, 25, 33, 0.08);
  color: #3A080A;
}

.setting-modal-content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(26, 10, 12, 0.25);
}

.setting-modal-body {
  padding: 1.35rem 1.25rem 1.5rem;
  background: linear-gradient(180deg, #FFF5F5 0%, #ffffff 50%);
}

.setting-modal-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #3A080A;
  margin: 0 0 1rem;
  padding-left: 10px;
  border-left: 4px solid #F5C518;
}

.setting-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #5c5151;
  margin-bottom: 0;
}

.setting-input {
  border-radius: 10px;
  border: 1px solid rgba(215, 25, 33, 0.15);
  background: #fff;
  font-size: 1rem;
  padding: 0.55rem 0.85rem;
}

.setting-input:focus {
  border-color: #F5C518;
  box-shadow: 0 0 0 3px rgba(245, 197, 24, 0.25);
}

.setting-btn-primary {
  min-width: 8.5rem;
  padding: 0.55rem 1.5rem;
  border-radius: 999px;
  font-weight: 600;
  border: 1px solid rgba(245, 197, 24, 0.4);
  color: #fff;
  background: linear-gradient(135deg, #3A080A 0%, #9B1218 50%, #D71921 100%);
  box-shadow: 0 4px 14px rgba(215, 25, 33, 0.35);
}

.setting-btn-primary:active {
  transform: translateY(1px);
}

.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: #D71921;
  border: 1px solid #D71921;
  border-radius: 8px;
  padding: 0 15px;
  font-weight: bold;
}
</style>
